import {get, post } from './http'

// 任务完成
export const finishTask = (id) => post('/min-program/v1/task/finish/' + id);
// 任务列表
export const getAlltaskList = (childId) => get('/min-program/v1/task/list/' + childId);
// 待完成任务列表
export const getUnfinshTaskList = (childId) => get('/min-program/v1/task/listUndoTaskByChildId?childId=' + childId);